import siteSearchGroup from '@/components/search-group.vue'
import { mailEvent } from '@/api/mail'

const columns = [
  {
    title: '',
    enTitle: 'Events Name',
    width: 250,
    dataIndex: 'name',
    slot: 'omission'
  },
  {
    title: '',
    enTitle: 'Letter Subject',
    width: 500,
    dataIndex: 'templateList',
    slot: 'templateList'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 50,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: {
    siteSearchGroup
  },
  data() {
    return {
      params: {},
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        showSizeChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      },
      columns: columns,
      dataSource: [
        {
          eventsName: 'Original PDF Built by Author',
          letterSubject: 'Author Changed Invited Due Date Confirmation  fffff'
        }
      ]
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList(page, size) {
      if (!page) {
        page = 1
      }
      if (!size) {
        size = this.pagination.size
      }
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: size
      })
      const { list, pageIndex, pageSize, total } = await mailEvent.get(data)
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    },
    handleClear() {
      this.params.keyword = ''
      this.getList()
    },
    associated(val) {
      this.$router.push(
        '/system/manage-email/actions/associated?event=' + val.event
      )
    }
  }
}
